import StoredLayout from '../../../layouts/StoredLayout';
import Search from './Search';
export default StoredLayout(Search);
